import React, { useContext, useMemo } from "react";
import {
  AppContext,
  GameBoardContext,
} from "../../../../context/createContext";
import SettingsAudio from "../../../../pages/settings/settingsAudio/SettingsAudio";
import {
  AudioWrapper,
  Subpage,
  SubpageWrapper,
  ToggleMenuContent,
} from "../ElementsStyles";
import { useTranslation } from "../../../../locale/context";

export default function Menu({ showMenu }: any) {
  const { funcs, settings } = useContext(GameBoardContext);
  const { handleSettings, handleSettingsSubpage } = funcs;
  const { jackpotIsActive } = useContext(AppContext);

  const { t } = useTranslation();
  const languagePack = useMemo(() => {
    return {
      history: t("common.menu.history"),
      rules: t("common.menu.rules"),
      jackpot: t("common.menu.jackpot"),
    };
  }, [t]);

  const handleSubPage = (page: string) => {
    handleSettingsSubpage(page);
    handleSettings(false);
  };
  return (
    <ToggleMenuContent showSettings={showMenu}>
      <SubpageWrapper>
        <Subpage
          showSettings={settings.showSettings}
          onClick={() => handleSubPage("History")}
        >
          {languagePack.history}
        </Subpage>
        <Subpage
          showSettings={settings.showSettings}
          onClick={() => handleSubPage("Game_Rules")}
        >
          {languagePack.rules}
        </Subpage>
        {jackpotIsActive && (
          <Subpage
            showSettings={settings.showSettings}
            onClick={() => handleSubPage("Jackpot_Rules")}
          >
            {languagePack.jackpot}
          </Subpage>
        )}
      </SubpageWrapper>
      <AudioWrapper>
        <SettingsAudio />
      </AudioWrapper>
    </ToggleMenuContent>
  );
}
